/**
 * created by zfy
 * 搜索相关api
 */
import * as API from './'
export default {
  //根据行政区划代码获取envlope定位
  getEnvByadmin:param=>{
    return API.GET(process.env.BASESERVER+'/search/getLocation',param);
  },


}



// WEBPACK FOOTER //
// ./src/api/api_search.js